var _path, _path2, _g, _g2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect5, _rect6, _path16, _rect7, _circle, _circle2, _circle3, _circle4, _rect8, _path17, _rect9, _circle5, _circle6, _circle7, _circle8, _rect10, _path18, _rect11, _circle9, _circle10, _circle11, _circle12, _rect12, _path19, _rect13, _circle13, _circle14, _circle15, _circle16, _rect14, _path20, _rect15, _rect16, _rect17, _path21, _path22, _path23, _path24, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 249,
    viewBox: "0 0 404 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.902 246.429C338.807 220.355 352 186.718 352 150C352 67.1573 284.843 0 202 0C119.157 0 52 67.1573 52 150C52 186.718 65.1931 220.355 87.0976 246.429H316.902Z",
    fill: "#24272E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161 61.3609C161 61.4297 160.999 61.4984 160.997 61.5668C165.285 61.6733 168.729 65.1828 168.729 69.4965C168.729 73.8093 165.287 77.3183 161 77.4262V77.4287H160.804C160.802 77.4287 160.799 77.4287 160.797 77.4287C160.794 77.4287 160.791 77.4287 160.789 77.4287H145.136V77.4262C145.068 77.4279 145 77.4287 144.932 77.4287C140.551 77.4287 137 73.8773 137 69.4965C137 65.1157 140.551 61.5643 144.932 61.5643C145.001 61.5643 145.07 61.5652 145.138 61.5669C145.136 61.4985 145.136 61.4298 145.136 61.3609C145.136 56.9801 148.687 53.4287 153.068 53.4287C157.449 53.4287 161 56.9801 161 61.3609Z",
    fill: "#505050"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.579 105.338C109.415 105.533 109.309 105.769 109.272 106.021L104.451 138.836C104.36 139.45 104.695 140.049 105.266 140.294L109.579 142.142C109.646 142.171 109.713 142.194 109.78 142.211C109.963 142.258 110.119 142.408 110.119 142.597V152.72C110.119 153.098 110.425 153.405 110.804 153.405C111.182 153.405 111.488 153.098 111.488 152.72V140.893C111.488 140.89 111.488 140.886 111.488 140.883L111.488 104.007C111.488 103.687 111.09 103.542 110.884 103.786L109.579 105.338Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.579 104.653C109.415 104.848 109.309 105.084 109.272 105.336L104.451 138.151C104.36 138.765 104.695 139.364 105.266 139.609L109.579 141.457C109.646 141.486 109.713 141.508 109.78 141.526C109.963 141.573 110.119 141.723 110.119 141.912V152.035C110.119 152.413 110.425 152.719 110.804 152.719C111.182 152.719 111.488 152.413 111.488 152.035V140.208C111.488 140.205 111.488 140.201 111.488 140.198L111.488 103.322C111.488 103.002 111.09 102.857 110.884 103.101L109.579 104.653Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7474 177.037C70.9977 177.081 71.2555 177.055 71.4919 176.961L102.321 164.729C102.899 164.5 103.25 163.911 103.176 163.294L102.621 158.634C102.612 158.562 102.598 158.493 102.58 158.426C102.529 158.244 102.581 158.034 102.744 157.94L111.511 152.878C111.839 152.689 111.951 152.27 111.762 151.943C111.573 151.615 111.154 151.503 110.826 151.692L100.582 157.607C100.58 157.608 100.578 157.609 100.576 157.61L94.2193 161.28L68.6396 176.049C68.3629 176.208 68.4364 176.626 68.7509 176.682L70.7474 177.037Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4049 176.694C70.6552 176.739 70.913 176.713 71.1494 176.619L101.979 164.387C102.556 164.157 102.907 163.568 102.834 162.951L102.278 158.292C102.269 158.22 102.256 158.15 102.237 158.083C102.187 157.901 102.238 157.692 102.402 157.597L111.169 152.536C111.496 152.347 111.608 151.928 111.419 151.6C111.23 151.273 110.811 151.161 110.484 151.35L100.24 157.264C100.238 157.265 100.235 157.267 100.233 157.268L68.2971 175.706C68.0204 175.866 68.0939 176.284 68.4085 176.34L70.4049 176.694Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.7 175.385C152.614 175.146 152.462 174.936 152.263 174.778L126.255 154.195C125.767 153.81 125.082 153.8 124.584 154.172L120.827 156.983C120.769 157.027 120.716 157.073 120.667 157.123C120.534 157.258 120.327 157.318 120.164 157.223L111.397 152.162C111.069 151.973 110.65 152.085 110.461 152.413C110.272 152.74 110.384 153.159 110.712 153.348L120.955 159.262C120.958 159.264 120.96 159.265 120.963 159.266L152.899 177.705C153.175 177.864 153.501 177.592 153.392 177.291L152.7 175.385Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.7 174.701C152.614 174.462 152.462 174.251 152.263 174.094L126.255 153.511C125.767 153.125 125.082 153.116 124.584 153.488L120.827 156.299C120.769 156.342 120.716 156.389 120.667 156.438C120.534 156.573 120.327 156.633 120.164 156.539L111.397 151.477C111.069 151.288 110.65 151.4 110.461 151.728C110.272 152.056 110.384 152.474 110.712 152.663L120.955 158.577C120.958 158.579 120.96 158.58 120.963 158.582L152.899 177.02C153.175 177.18 153.501 176.907 153.392 176.607L152.7 174.701Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.564 154.808C113.542 154.39 114.228 153.419 114.228 152.288C114.228 150.775 113.001 149.549 111.488 149.549C109.975 149.549 108.749 150.775 108.749 152.288C108.749 153.419 109.434 154.39 110.413 154.808L104.982 245.429H117.994L112.564 154.808Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.879 154.808C112.857 154.39 113.543 153.419 113.543 152.288C113.543 150.775 112.316 149.549 110.803 149.549C109.291 149.549 108.064 150.775 108.064 152.288C108.064 153.419 108.75 154.39 109.728 154.808L104.297 245.429H117.31L111.879 154.808Z",
    fill: "#8B8B8B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 122.429,
    width: 26.7138,
    height: 62.9968,
    rx: 13.3569,
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.759,
    y: 147.946,
    width: 1.59486,
    height: 98.4823,
    rx: 0.797428,
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.338,
    y: 151.448,
    width: 1.59486,
    height: 13.443,
    rx: 0.797428,
    transform: "rotate(30 345.338 151.448)",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.59486,
    height: 18.9128,
    rx: 0.797428,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 339.201 172.919)",
    fill: "#8B8B8B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 70.4287,
    width: 38.1994,
    height: 90.0821,
    rx: 19.0997,
    fill: "#505050"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 316.245,
    y: 106.917,
    width: 2.28056,
    height: 140.825,
    rx: 1.14028,
    fill: "#8B8B8B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 325.653,
    y: 111.925,
    width: 2.28056,
    height: 19.2228,
    rx: 1.14028,
    transform: "rotate(30 325.653 111.925)",
    fill: "#8B8B8B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.28056,
    height: 27.0444,
    rx: 1.14028,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 316.876 142.627)",
    fill: "#8B8B8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3819 28.139C71.1245 28.445 70.9574 28.8166 70.8993 29.2122L63.3179 80.8133C63.1759 81.78 63.7024 82.7212 64.6004 83.1061L71.3824 86.0127C71.4871 86.0576 71.5927 86.0935 71.6985 86.1209C71.9862 86.1954 72.2308 86.43 72.2308 86.7273V102.646C72.2308 103.24 72.713 103.722 73.3077 103.722C73.9025 103.722 74.3847 103.24 74.3847 102.646V84.0477C74.3847 84.0428 74.3847 84.0379 74.3847 84.033L74.3847 26.0454C74.3847 25.543 73.7575 25.3143 73.4341 25.6988L71.3819 28.139Z",
    fill: "#505050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3819 27.0618C71.1245 27.3678 70.9574 27.7394 70.8993 28.135L63.3179 79.7362C63.1759 80.7029 63.7024 81.6441 64.6004 82.029L71.3824 84.9355C71.4871 84.9804 71.5927 85.0163 71.6985 85.0437C71.9862 85.1183 72.2308 85.3529 72.2308 85.6501V101.568C72.2308 102.163 72.713 102.645 73.3077 102.645C73.9025 102.645 74.3847 102.163 74.3847 101.568V82.9705C74.3847 82.9656 74.3847 82.9607 74.3847 82.9558L74.3847 24.9682C74.3847 24.4658 73.7575 24.2372 73.4341 24.6217L71.3819 27.0618Z",
    fill: "#8B8B8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3201 140.884C10.7138 140.953 11.1191 140.912 11.4908 140.765L59.9694 121.53C60.8776 121.17 61.4295 120.243 61.3138 119.273L60.4399 111.946C60.4264 111.833 60.4047 111.724 60.3756 111.618C60.2963 111.332 60.3772 111.003 60.6346 110.854L74.4202 102.895C74.9353 102.598 75.1117 101.939 74.8144 101.424C74.517 100.909 73.8583 100.732 73.3433 101.03L57.2351 110.33C57.2315 110.332 57.2279 110.334 57.2243 110.336L7.00561 139.33C6.57051 139.581 6.68606 140.239 7.18074 140.326L10.3201 140.884Z",
    fill: "#505050"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78176 140.345C10.1755 140.415 10.5808 140.374 10.9525 140.227L59.4311 120.992C60.3393 120.632 60.8912 119.705 60.7754 118.735L59.9016 111.408C59.8881 111.295 59.8664 111.186 59.8373 111.08C59.758 110.794 59.8389 110.465 60.0963 110.316L73.8819 102.357C74.3969 102.06 74.5734 101.401 74.2761 100.886C73.9787 100.371 73.32 100.194 72.8049 100.492L56.6968 109.792C56.6932 109.794 56.6896 109.796 56.686 109.798L6.46731 138.792C6.03221 139.043 6.14776 139.7 6.64244 139.788L9.78176 140.345Z",
    fill: "#8B8B8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.189 138.287C139.053 137.911 138.815 137.58 138.501 137.332L97.604 104.966C96.8379 104.359 95.7595 104.345 94.9771 104.93L89.069 109.35C88.9778 109.418 88.8939 109.492 88.8173 109.57C88.6088 109.782 88.2834 109.876 88.0259 109.728L74.2403 101.769C73.7253 101.471 73.0666 101.648 72.7692 102.163C72.4719 102.678 72.6483 103.336 73.1634 103.634L89.2703 112.933C89.2743 112.935 89.2783 112.938 89.2823 112.94L139.501 141.934C139.936 142.185 140.448 141.756 140.276 141.284L139.189 138.287Z",
    fill: "#505050"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.189 137.21C139.053 136.834 138.815 136.504 138.501 136.255L97.604 103.889C96.8379 103.283 95.7595 103.268 94.9771 103.853L89.069 108.274C88.9778 108.342 88.8939 108.415 88.8173 108.493C88.6088 108.705 88.2834 108.8 88.0259 108.651L74.2403 100.692C73.7253 100.394 73.0666 100.571 72.7692 101.086C72.4719 101.601 72.6483 102.26 73.1634 102.557L89.2705 111.857C89.2744 111.859 89.2784 111.861 89.2823 111.863L139.501 140.857C139.936 141.108 140.448 140.68 140.276 140.207L139.189 137.21Z",
    fill: "#8B8B8B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0761 105.93C77.6143 105.273 78.6923 103.746 78.6923 101.967C78.6923 99.5883 76.7637 97.6597 74.3846 97.6597C72.0055 97.6597 70.0769 99.5883 70.0769 101.967C70.0769 103.746 71.1548 105.273 72.6931 105.93L64.1538 248.429H84.6154L76.0761 105.93Z",
    fill: "#505050"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9992 105.93C76.5374 105.273 77.6154 103.746 77.6154 101.967C77.6154 99.5883 75.6867 97.6597 73.3077 97.6597C70.9286 97.6597 69 99.5883 69 101.967C69 103.746 70.0779 105.273 71.6161 105.93L63.0769 248.429H83.5384L74.9992 105.93Z",
    fill: "#8B8B8B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.103 89.4287C259.103 89.4634 259.102 89.498 259.101 89.5325C261.264 89.5863 263 91.356 263 93.5313C263 95.7061 261.264 97.4755 259.103 97.53V97.5312H259.01C259.007 97.5313 259.003 97.5313 259 97.5313C258.996 97.5313 258.993 97.5313 258.989 97.5312H251.103V97.53C251.069 97.5308 251.034 97.5313 251 97.5313C248.791 97.5313 247 95.7404 247 93.5313C247 91.3221 248.791 89.5313 251 89.5313C251.035 89.5313 251.069 89.5317 251.104 89.5326C251.103 89.4981 251.103 89.4634 251.103 89.4287C251.103 87.2196 252.894 85.4287 255.103 85.4287C257.312 85.4287 259.103 87.2196 259.103 89.4287Z",
    fill: "#505050"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281 131.742C281 131.762 281 131.782 280.999 131.802C282.25 131.833 283.254 132.857 283.254 134.115C283.254 135.373 282.25 136.396 281 136.428V136.429H280.942C280.942 136.429 280.941 136.429 280.941 136.429C280.94 136.429 280.94 136.429 280.939 136.429H276.373V136.428C276.353 136.428 276.333 136.429 276.314 136.429C275.036 136.429 274 135.393 274 134.115C274 132.837 275.036 131.802 276.314 131.802C276.334 131.802 276.354 131.802 276.374 131.802C276.373 131.782 276.373 131.762 276.373 131.742C276.373 130.465 277.409 129.429 278.687 129.429C279.964 129.429 281 130.465 281 131.742Z",
    fill: "#505050"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.2 40.2568C217.2 33.1721 222.943 27.4287 230.028 27.4287C235.286 27.4287 239.804 30.5915 241.786 35.1182C243.061 34.2163 244.617 33.6863 246.298 33.6863C250.252 33.6863 253.52 36.6196 254.046 40.4287H256.98C260.57 40.4287 263.48 43.3389 263.48 46.9287C263.48 50.5186 260.57 53.4287 256.98 53.4287H218.5C214.91 53.4287 212 50.5186 212 46.9287C212 43.7828 214.235 41.1589 217.203 40.558C217.201 40.4579 217.2 40.3575 217.2 40.2568Z",
    fill: "#505050"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1212 88.6616C92.1212 85.7716 94.4641 83.4287 97.3541 83.4287C99.4988 83.4287 101.342 84.7189 102.15 86.5655C102.67 86.1975 103.305 85.9813 103.991 85.9813C105.604 85.9813 106.937 87.1779 107.152 88.7317H108.348C109.813 88.7317 111 89.9189 111 91.3833C111 92.8476 109.813 94.0348 108.348 94.0348H92.6515C91.1871 94.0348 90 92.8476 90 91.3833C90 90.1 90.9116 89.0296 92.1226 88.7845C92.1217 88.7437 92.1212 88.7027 92.1212 88.6616Z",
    fill: "#505050"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 246.429C0 245.324 0.89543 244.429 2 244.429H402C403.105 244.429 404 245.324 404 246.429C404 247.533 403.105 248.429 402 248.429H2C0.89543 248.429 0 247.533 0 246.429Z",
    fill: "#1573FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 135.429,
    width: 79,
    height: 109,
    fill: "#1B2028"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 107.429,
    width: 103.126,
    height: 28.3971,
    rx: 1.99278,
    fill: "#1573FE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.44 132.837C141.44 131.736 142.333 130.844 143.433 130.844H180.798C181.898 130.844 182.791 131.736 182.791 132.837V135.826H141.44V132.837Z",
    fill: "#1A2A42"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 190.762,
    y: 117.891,
    width: 19.4296,
    height: 2.98917,
    rx: 0.498195,
    fill: "#1A2A42"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130.48,
    cy: 112.909,
    r: 1.49458,
    fill: "#FF4343"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.444,
    cy: 112.909,
    r: 1.49458,
    fill: "#28C760"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.462,
    cy: 112.909,
    r: 1.49458,
    fill: "#FFA113"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.17,
    cy: 119.385,
    r: 3.98556,
    fill: "#1A2A42"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 141.812,
    width: 103.126,
    height: 28.3971,
    rx: 1.99278,
    fill: "#1573FE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141.44 167.219C141.44 166.119 142.333 165.227 143.433 165.227H180.798C181.898 165.227 182.791 166.119 182.791 167.219V170.209H141.44V167.219Z",
    fill: "#1A2A42"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 190.762,
    y: 152.273,
    width: 19.4296,
    height: 2.98917,
    rx: 0.498195,
    fill: "#1A2A42"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.48,
    cy: 147.291,
    r: 1.49458,
    fill: "#FF4343"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.444,
    cy: 147.291,
    r: 1.49458,
    fill: "#28C760"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.462,
    cy: 147.291,
    r: 1.49458,
    fill: "#FFA113"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.17,
    cy: 153.768,
    r: 3.98556,
    fill: "#1A2A42"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 176.194,
    width: 103.126,
    height: 28.3971,
    rx: 1.99278,
    fill: "#1573FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.44 201.602C141.44 200.501 142.333 199.609 143.433 199.609H180.798C181.898 199.609 182.791 200.501 182.791 201.602V204.591H141.44V201.602Z",
    fill: "#1A2A42"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 190.762,
    y: 186.656,
    width: 19.4296,
    height: 2.98917,
    rx: 0.498195,
    fill: "#1A2A42"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.48,
    cy: 181.674,
    r: 1.49458,
    fill: "#FF4343"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.444,
    cy: 181.674,
    r: 1.49458,
    fill: "#28C760"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.462,
    cy: 181.674,
    r: 1.49458,
    fill: "#FFA113"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.17,
    cy: 188.151,
    r: 3.98556,
    fill: "#1A2A42"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 210.577,
    width: 103.126,
    height: 28.3971,
    rx: 1.99278,
    fill: "#1573FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M141.44 235.984C141.44 234.884 142.333 233.992 143.433 233.992H180.798C181.898 233.992 182.791 234.884 182.791 235.984V238.974H141.44V235.984Z",
    fill: "#1A2A42"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 190.762,
    y: 221.039,
    width: 19.4296,
    height: 2.98917,
    rx: 0.498195,
    fill: "#1A2A42"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.48,
    cy: 216.057,
    r: 1.49458,
    fill: "#FF4343"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.444,
    cy: 216.057,
    r: 1.49458,
    fill: "#28C760"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.462,
    cy: 216.057,
    r: 1.49458,
    fill: "#FFA113"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.17,
    cy: 222.533,
    r: 3.98556,
    fill: "#1A2A42"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 158.429,
    width: 24,
    height: 24,
    rx: 1.82606,
    fill: "#1573FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.312 158.582C281.831 167.994 273.779 175.225 264 175.429V160.255C264 159.246 264.818 158.429 265.826 158.429H282.579C282.84 158.429 283.087 158.483 283.312 158.582Z",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 267.273,
    y: 161.702,
    width: 17.4545,
    height: 17.4545,
    rx: 8.72727,
    fill: "#1A2A42"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 271.636,
    y: 168.792,
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#505050"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 277.091,
    y: 168.792,
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#505050"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 193.929H272.5C276.366 193.929 279.5 197.063 279.5 200.929C279.5 204.795 276.366 207.929 272.5 207.929L255.19 207.929L254.147 207.929H246C241.858 207.929 238.5 211.287 238.5 215.429C238.5 219.571 241.858 222.929 246 222.929L282 222.929V219.929L246 219.929C243.515 219.929 241.5 217.914 241.5 215.429C241.5 212.943 243.515 210.929 246 210.929H254.147L255.19 210.929L272.5 210.929C278.023 210.929 282.5 206.452 282.5 200.929C282.5 195.406 278.023 190.929 272.5 190.929H228V193.929Z",
    fill: "#1B2028"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M290 217.429H295C295.552 217.429 296 217.876 296 218.429C296 218.981 295.552 219.429 295 219.429H290V217.429Z",
    fill: "#1B2028"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M290 223.429H295C295.552 223.429 296 223.876 296 224.429C296 224.981 295.552 225.429 295 225.429H290V223.429Z",
    fill: "#1B2028"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M277 221.326C277 218.319 279.438 215.881 282.445 215.881H287.714V226.771H282.445C279.438 226.771 277 224.333 277 221.326Z",
    fill: "#1573FE"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 214.429,
    width: 3,
    height: 14,
    rx: 0.72601,
    fill: "#1573FE"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 202.429,
    width: 0.99639,
    height: 5.97834,
    rx: 0.498195,
    fill: "#505050"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 297.484,
    y: 212.891,
    width: 0.99639,
    height: 5.97834,
    rx: 0.498195,
    transform: "rotate(-90 297.484 212.891)",
    fill: "#505050"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 296.694,
    y: 209.852,
    width: 0.99639,
    height: 5.97834,
    rx: 0.498195,
    transform: "rotate(-135 296.694 209.852)",
    fill: "#505050"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 286.462,
    y: 241.891,
    width: 0.99639,
    height: 5.97834,
    rx: 0.498195,
    transform: "rotate(-180 286.462 241.891)",
    fill: "#505050"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 281.978,
    y: 231.429,
    width: 0.99639,
    height: 5.97834,
    rx: 0.498195,
    transform: "rotate(90 281.978 231.429)",
    fill: "#505050"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 282.768,
    y: 234.468,
    width: 0.99639,
    height: 5.97834,
    rx: 0.498195,
    transform: "rotate(45 282.768 234.468)",
    fill: "#505050"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.496 135.826C182.829 132.071 183 128.27 183 124.429C183 118.664 182.616 112.99 181.872 107.429H126.993C125.892 107.429 125 108.321 125 109.421V133.833C125 134.934 125.892 135.826 126.993 135.826H141.44H182.496ZM181.82 141.811H126.993C125.892 141.811 125 142.704 125 143.804V168.216C125 169.316 125.892 170.209 126.993 170.209H174.498C177.983 161.195 180.469 151.684 181.82 141.811ZM172.006 176.194H126.993C125.892 176.194 125 177.086 125 178.187V202.598C125 203.699 125.892 204.591 126.993 204.591L141.44 204.591H154.509C161.518 195.989 167.422 186.451 172.006 176.194ZM149.315 210.577H126.993C125.892 210.577 125 211.469 125 212.569V231.067C133.944 225.269 142.112 218.375 149.315 210.577Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError500);
export default __webpack_public_path__ + "static/media/Error500.773c5dfe7d3c6c0e3b30b30e5cce4040.svg";
export { ForwardRef as ReactComponent };